export const ADMIN_SIGNIN_REQUEST = 'ADMIN_SIGNIN_REQUEST'
export const ADMIN_SIGNIN_SUCCESS = 'ADMIN_SIGNIN_SUCCESS'
export const ADMIN_SIGNIN_FAILED = 'ADMIN_SIGNIN_FAILED'
export const ADMIN_LOGOUT = 'ADMIN_LOGOUT'


export const UPLOAD_IMAGE_TO_CLOUD_REQUEST = 'UPLOAD_IMAGE_TO_CLOUD_REQUEST'
export const UPLOAD_IMAGE_TO_CLOUD_SUCCESS = 'UPLOAD_IMAGE_TO_CLOUD_SUCCESS'
export const UPLOAD_IMAGE_TO_CLOUD_FAILED = 'UPLOAD_IMAGE_TO_CLOUD_FAILED'